import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import exportToExcel from "../Report/ExportExcel";

const tripTableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginBottom: "20px",
};

const thTdStyle = {
  padding: "8px",
  border: "1px solid #ddd",
  textAlign: "left",
};

const thStyle = {
  backgroundColor: "#f2f2f2",
};

const DriverTrips = ({ name, prRef, trips }) => {
  const columns = [
    "Date",
    "Pickup Place",
    "Destination",
    "Actual Price",
    "Estimated Price",
    "Passenger Name",
    "Passenger Phone",
    "Payment Method",
    "Status",
  ];

  return (
    <div ref={prRef}>
      <Header title={"Driver Trips"} subTitle={"Trips of " + name + " for"} />
      <table style={tripTableStyle}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column} style={{ ...thTdStyle, ...thStyle }}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {trips.map((trip, index) => (
            <tr key={index}>
              <td style={thTdStyle}>{trip.createdAt}</td>
              <td style={thTdStyle}>{trip.pickUpPlace}</td>
              <td style={thTdStyle}>{trip.destinationPlace}</td>
              <td style={thTdStyle}>{trip.actualPrice}</td>

              <td style={thTdStyle}>{trip.estimatedPrice}</td>
              <td
                style={thTdStyle}
              >{`${trip.passenger.firstName} ${trip.passenger.lastName}`}</td>
              <td style={thTdStyle}>{trip.passenger.phoneNumber}</td>

              <td style={thTdStyle}>{trip.paymentMethod}</td>
              <td style={thTdStyle}>{trip.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <Footer />
    </div>
  );
};

export const exportExcelDriverTrips = (name, trips) => {
  const formattedTrips = trips.map((trip) => ({
    Date: trip.createdAt,
    "Pickup Place": trip.pickUpPlace,
    Destination: trip.destinationPlace,
    "Actual Price": trip.actualPrice,
    "Estimated Price": trip.estimatedPrice,
    "Passenger Name": `${trip.passenger.firstName} ${trip.passenger.lastName}`,
    "Passenger Phone": trip.passenger.phoneNumber,
    "Payment Method": trip.paymentMethod,
    Status: trip.status,
  }));

  exportToExcel(formattedTrips, `DriverTrips_${name}`, [
    "Date",
    "Pickup Place",
    "Destination",
    "Actual Price",
    "Estimated Price",
    "Passenger Name",
    "Passenger Phone",
    "Payment Method",
    "Status",
  ]);
};

export default DriverTrips;
